const UserIntegrationDetailsQueryParams = {
  startDate: 'StartDate',
  endDate: 'EndDate',
  skip: 'Skip',
  take: 'Take',
  userType: 'UserType',
};

export default UserIntegrationDetailsQueryParams;
